module.exports = __webpack_public_path__ + "img/processing.7d1bac01.svg";